import type { Client } from '@urql/core'
import { graphql } from 'app/generated/gql'

import type { Workspace as WorkspaceType, WorkspaceListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const WORKSPACE_FIELDS = `archived carestackId createdDate id lastFacebookLeadsErrorDate lastPmsSyncDate maxEnrollmentsPerHour maxOutboundDaily maxOutboundMonthly name orgId orgTags promptAddendum updatedDate version`

const LIST_QUERY = graphql(`
  query Workspaces($search: String, $pagination: PaginationInput, $sort: SortInput) {
    workspaces(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        archived
        carestackId
        createdDate
        id
        lastFacebookLeadsErrorDate
        lastPmsSyncDate
        maxEnrollmentsPerHour
        maxOutboundDaily
        maxOutboundMonthly
        name
        orgId
        orgTags
        promptAddendum
        updatedDate
        version
      }
      total
      page
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateWorkspace($id: ID!, $input: UpdateWorkspaceInput!) {
    updateWorkspace(id: $id, input: $input) {
      archived
      carestackId
      createdDate
      id
      lastFacebookLeadsErrorDate
      lastPmsSyncDate
      maxEnrollmentsPerHour
      maxOutboundDaily
      maxOutboundMonthly
      name
      orgId
      orgTags
      promptAddendum
      updatedDate
      version
    }
  }
`)

// GET_QUERY enables WorkspaceStore.fetchOne() — used by AuthStore to load
// the current user's workspace details after login/switch.
const GET_QUERY = graphql(`
  query Workspace($id: ID!) {
    workspace(id: $id) {
      archived
      carestackId
      createdDate
      id
      lastFacebookLeadsErrorDate
      lastPmsSyncDate
      maxEnrollmentsPerHour
      maxOutboundDaily
      maxOutboundMonthly
      name
      orgId
      orgTags
      promptAddendum
      updatedDate
      version
    }
  }
`)

const DELETE_MUTATION = graphql(`
  mutation DeleteWorkspace($id: ID!) {
    deleteWorkspace(id: $id)
  }
`)

export class WorkspaceStore extends EntityStore<WorkspaceType, WorkspaceListResult, undefined, typeof UPDATE_MUTATION> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      updateMutation: UPDATE_MUTATION,
      deleteMutation: DELETE_MUTATION,
      typename: `Workspace`,
      extractList: (data: any) => data.workspaces,
      extractOne: (data: any) => data.workspace,
      extractMutated: (data: any) => data.updateWorkspace,
    })
  }
}
